import React from "react";
import dynamic from "next/dynamic";
import { Flex, forwardRef, Spinner } from "@chakra-ui/react";

import "react-quill/dist/quill.snow.css";

const QuillLoading = (): JSX.Element => (
  <Flex
    width="100%"
    flex={1}
    py={3}
    alignItems="center"
    justifyContent="center"
    style={{
      borderRadius: ".375rem",
      background: "#F0F0F0",
    }}
  >
    <Spinner />
  </Flex>
);

const ReactQuill = dynamic(() => import("./Editor"), {
  ssr: false,
  loading: QuillLoading,
});

type Props = {
  value: string;
  onChange: (content: string, delta, source, editor) => void;
  hideMediaIcons?: boolean;
  hideCloudIcons?: boolean;
  isInvalid?: boolean;
  autoFocus?: boolean;
  newsletter?: boolean;
};

const QuillEditor = forwardRef(
  (
    {
      value,
      onChange,
      hideMediaIcons = false,
      hideCloudIcons = false,
      isInvalid = false,
      autoFocus = false,
      newsletter = false,
    }: Props,
    ref
  ): React.ReactElement => {
    return (
      <ReactQuill
        value={value}
        onChange={onChange}
        hideMediaIcons={hideMediaIcons}
        hideCloudIcons={hideCloudIcons}
        newsletter={newsletter}
        isInvalid={isInvalid}
        autoFocus={autoFocus}
        ref={ref}
      />
    );
  }
);

QuillEditor.displayName = "QuillEditor";

export default QuillEditor;
